import React from "react";
import { Search } from "lucide-react";
import { useSearch } from "../../contexts/SearchContext";
import { useOrg } from "../../contexts/OrganizationContext";

// Must stay in sync with SidebarSearchHeader's FILTER_KEYS.
const FILTER_KEYS = ["radius", "tp", "gender", "age_range", "open_now", "open_on", "area_sort", "referral"];

function SearchSummaryBanner({ onEdit }) {
  const { params, categorySelections } = useSearch();
  const { organization } = useOrg();

  const labels = [
    ...categorySelections.map((c) => c.name),
    ...(params.terms || []),
  ];
  const summaryText = labels.join(", ");

  const locationSummary = params.location
    || `all of ${organization.serviceLocale?.stateName || "the selected area"}`;

  const filterCount = FILTER_KEYS.filter((key) => {
    const value = params[key];
    return Array.isArray(value) ? value.length > 0 : !!value;
  }).length;

  return (
    <div className="search-summary-banner">
      <div className="search-summary-banner-text">
        <p className="search-summary-banner-terms">{summaryText}</p>
        <p className="search-summary-banner-meta">
          in {locationSummary}
          {filterCount > 0 && (
            <span className="search-summary-banner-filters">
              , +{filterCount} {filterCount === 1 ? "Filter" : "Filters"}
            </span>
          )}
        </p>
      </div>
      <button
        type="button"
        className="search-summary-banner-edit"
        onClick={onEdit}
      >
        <Search aria-hidden="true" size={16} strokeWidth={2} />
        <span>Edit</span>
      </button>
    </div>
  );
}

export default SearchSummaryBanner;
